import React, { useState } from 'react';
import title from 'Icons/RM_Title.png';
import Logo from 'Icons/RMlogo.png';
import { showAlertSnackBar } from 'utils/Global';
import { ReactComponent as User } from 'Icons/Dashboard/User.svg';
import { useNavigate } from 'react-router-dom';
import UserGroupService from 'business/services/UserGroupService';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import useModel from 'business/models/useModel';
import { FormActionButton } from 'components/Button';
import useAppInfo from 'CustomHooks/useAppInfo';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [username, setUserName] = useState('');
  const [forgotPassword] = useModel(UserGroupService, 'forgotPassword');
  const appInfo = useAppInfo();
  const appVersion = appInfo?.version;
  const appCopyRights = appInfo?.copyRight;

  const openFormulatrixWebsite = (e) => {
    window.open('http://www.formulatrix.com/', '_blank');
  };

  const changeUserName = (e) => {
    setUserName(e.target.value);
  };

  const handleBackToLoginClick = () => {
    navigate('/login');
  };

  const handlInputOTPClick = () => {
    navigate('/inputOTP');
  };

  const submitForgotPassword = async () => {
    const res: boolean = await forgotPassword(username);
    if (res == true) {
      showAlertSnackBar(
        EAlertType.SUCCESS,
        ESnackBarPosition.TOP,
        'A code has been sent to your email. It will expire in 1 hour. Please open your email and enter the code to verify your account.',
      );
      navigate('/login');
    } else {
      showAlertSnackBar(
        EAlertType.ERROR,
        ESnackBarPosition.TOP,
        'Request failed. Contact your administrator to reset your password.',
      );
    }
  };

  return (
    <div id="forgot-password-main-container" className="mainContainer">
      <div id="forgot-password-header-row" className="headerRow">
        <div id="forgot-password-header-logo" className="headerLogo">
          <img id="forgot-password-img-logo" src={Logo} />
        </div>
        <div id="forgot-password-header-title" className="headerTitle">
          <img
            id="forgot-password-img-title-image"
            className="titleImage"
            src={title}
            alt="RM title"
          />
        </div>
      </div>
      <div id="forgot-password-inner-container" className="innerContainer">
        <div id="forgot-password-login" className="login flex-y-center flex-column">
          <div
            id="forgot-password-login-heading"
            className="loginHeading flex-y-center flex-column"
          >
            <div id="forgot-password-login-registered-text">
              ROCK MAKER
              <span id="forgot-password-registered-logo" className="registeredLogo">
                &#174;
              </span>{' '}
              Crystallization Software
            </div>
            <div id="forgot-password-login-sub-heading" className="loginSubHeading">
              Please enter your username / email to reset password
            </div>
          </div>

          <div
            id="forgot-password-login-form"
            className="loginForm flex-y-center flex-column"
          >
            <div id="forgot-password-user-icon" className="userIcon">
              <User />
            </div>
            <div id="forgot-password-fields-username" className="fields">
              <input
                id="forgot-password-input-username"
                className="inputField"
                placeholder="Username / Email"
                value={username}
                onChange={changeUserName}
                autoFocus
              />
            </div>
            <div
              id="forgot-password-sumbit-action-button"
              className="fields flex-x-center"
            >
              <FormActionButton
                onSaveClick={submitForgotPassword}
                onDiscardClick={handleBackToLoginClick}
                saveText={'Proceed'}
                discardText={'Cancel'}
                saveDisabled={username == ''}
              />
            </div>
            <div
              id="forgot-password-fields-forget-password"
              className="fields flex justify-between"
            >
              <a
                id="forgot-password-input-otp-click"
                className="forgetPassword"
                onClick={handlInputOTPClick}
              >
                I have a code
              </a>
            </div>
          </div>
          <div
            id="forgot-password-buttom-details"
            className="row bottomDetails flex flex-space-between"
          >
            <div
              id="forgot-password-buttom-details-version"
              className="col-md-4 bottomDetailsCols"
            >
              Version {appVersion}
            </div>
            <div
              id="forgot-password-buttom-details-cols-selected"
              className="col-md-4 bottomDetailsCols bottomDetailsColsSelected"
              onClick={openFormulatrixWebsite}
            >
              Formulatrix Inc.
            </div>
            <div
              id="forgot-password-buttom-details-copy-rights"
              className="col-md-4 bottomDetailsCols"
            >
              ©{appCopyRights}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ForgotPassword;
